import { useFlags } from 'launchdarkly-react-client-sdk';
import { Navigate } from 'react-router';
import { Inline } from '../../design-system/inline/inline';
import { Stack } from '../../design-system/stack/stack';

const DashboardPage = () => {
  const { isDashboardPageLive } = useFlags();

  if (!isDashboardPageLive) {
    return <Navigate to="/" />;
  }

  return (
    <Stack align="stretch" className="min-h-screen py-2 pr-2">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-md border border-border bg-background shadow-xs">
        <Stack align="stretch" className="bg-white px-6 pt-4" space={10}>
          <Inline justify="between" className="h-[42px]">
            <h1 className="text-2xl font-semibold text-black">Dashboard</h1>
          </Inline>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default DashboardPage;
